import { createSlice } from "@reduxjs/toolkit";


interface InitialStateModel {
  
  isShowMarkerTooltip:boolean;
  selectedMarkerItemData:any|null
}

const InitialState: InitialStateModel = {
 isShowMarkerTooltip:false,
 selectedMarkerItemData:null
};

const mapListSlice = createSlice({
  name: "realStateSlice",
  initialState: InitialState,
  reducers: {
    handleSetShowMarkerTooltip: (state, action) => {
 
      state.isShowMarkerTooltip= action.payload.status;
    },
    handleSetSelectedMarkerData: (state, action) => {
 
      state.selectedMarkerItemData= action.payload.data;
    },
   
   
  },
});

export const {
  handleSetSelectedMarkerData,
  handleSetShowMarkerTooltip,
 
} =  mapListSlice.actions;
export default  mapListSlice;
